module.exports = __webpack_public_path__ + "img/placeholder_lesson.6f52e011.png";